module.exports = __webpack_public_path__ + "img/pre_20211001_4pll.d39d9832.png";